<template>
  <v-timeline-item
    class="item"
    :color="item.fromHiL ? '#60A694' : '#FF7C5D'"
    small
  >
    <v-layout pt-3>
      <v-flex xs2>
        <strong>{{ item.date | shortDate }}</strong>
      </v-flex>
      <v-flex>
        <strong>
          <template v-if="item.isAggregate">
            <template v-if="item.type === 'BIEN_SOUMIS'">
              {{ item.paramsGroup.length }} nouveaux biens ont été soumis
            </template>
            <template v-else-if="item.type === 'BIEN_JUGE'">
              {{ item.paramsGroup.length }} biens ont été jugés
            </template>
            <template v-else-if="item.type === 'COMMENTAIRE_BIEN'">
              {{ item.paramsGroup.length }} nouveaux commentaires sur des biens
            </template>
            <template v-else
              >Inconnu</template
            >
          </template>
          <template v-else>
            <template v-if="item.type === 'BIEN_SOUMIS'">
              <template v-if="item.params && item.params.host">
                Un
                <a
                  target="_blank"
                  :href="
                    `/leases/project/${item.projectId}/proposals/${
                      item.params.host
                    }`
                  "
                  @click="markAsRead"
                  >nouveau bien</a
                >
                a été soumis
              </template>
              <template v-else
                >Un nouveau bien a été soumis</template
              >
            </template>
            <template v-else-if="item.type === 'BIEN_JUGE'">
              Un bien a été jugé
            </template>
            <template v-else-if="item.type === 'BIEN_VISITE'">
              Une visite a été enregistrée
            </template>
            <template v-else-if="item.type === 'BIEN_VISITE_ANNULE'">
              Une visite a été annulée
            </template>
            <template v-else-if="item.type === 'BIEN_CHOISI'">
              Un bien final a été défini
            </template>
            <template v-else-if="item.type === 'COMMENTAIRE_BIEN'">
              <template v-if="item.params && item.params.host">
                <a
                  target="_blank"
                  :href="
                    `/leases/project/${item.projectId}/proposals/${
                      item.params.host
                    }/comments`
                  "
                  @click="markAsRead"
                  >Commentaire</a
                >
                sur un bien
              </template>
              <template v-else
                >Commentaire sur un bien</template
              >
            </template>
            <template v-else-if="item.type === 'COMMENTAIRE_PROJET'">
              Commentaire sur un projet
            </template>
            <template v-else-if="item.type === 'NOMBRE_ANNONCES_VUES'">
              Nous avons vu {{ this.item.params.count }} annonces
            </template>
            <template v-else-if="item.type === 'CHANGEMENT_STATUT'">
              Le statut du dossier a changé
            </template>
            <template v-else-if="item.type === 'SIGNATURE_BAIL'">
              Signature du bail
            </template>
            <template v-else-if="item.type === 'FEEDBACK'">
              Avis envoyé
            </template>
            <template v-else-if="item.type === 'VISIT_ASSIST'">
              Demande d'accompagnement: {{ this.item.params ? "Oui" : "Non" }}
            </template>
            <template v-else
              >Inconnu</template
            >
          </template>
        </strong>
        <div class="caption mb-2" v-if="description != null">
          {{ description }}
        </div>
      </v-flex>
      <v-flex xs1 v-if="item.read">
        <span>
          <v-icon class="mr-2" style="font-size: 14px">check</v-icon>
        </span>
      </v-flex>
    </v-layout>
  </v-timeline-item>
</template>

<script>
import { fetchHil } from "@/utils";

export default {
  props: ["item"],
  computed: {
    description() {
      switch (this.item.type) {
        case "BIEN_JUGE":
          if (this.item.isAggregate) {
            return null;
          } else {
            return `Le client ${
              this.item.params.value === "liked" ? "a aimé" : "n'a pas aimé"
            } le bien.`;
          }
        case "BIEN_VISITE_ANNULE": {
          let reason = this.item.params.reason;
          return `Annulé par ${
            reason === "hil"
              ? "Home In Love"
              : reason === "agency"
              ? "l'agence"
              : reason === "client"
              ? "le client"
              : "Inconnu"
          }`;
        }
        case "SIGNATURE_BAIL":
          return `Date fixée au ${this.$options.filters.date(
            this.item.params.date
          )}`;
        case "FEEDBACK":
          return `Votre avis a été pris en compte, merci d'avoir pris le temps de répondre à notre questionnaire`;
        default:
          return null;
      }
    }
  },
  methods: {
    async markAsRead() {
      this.item.read = new Date();
      const resp = await fetchHil(`/timeline/${this.item._id}/read`, {
        method: "PUT"
      });
      if (resp.ok) {
        this.$forceUpdate();
      }
    }
  }
};
</script>
